import { getSuggestionAtIndex, getSuggestionsSet, getSuggestionText, setSearchTextForSuggestion, setSearchText, } from 'owa-mail-search-store';
import { SuggestionKind, lazyLogSearchBoxStateChanged } from 'owa-search-service';
import * as suggestionPillActions from 'owa-mail-search-store/lib/actions/suggestionPillActions';
import { mutatorAction } from 'satcheljs';
import getSuggestionSegments from 'owa-mail-search-store/lib/helpers/getSuggestionSegments';
import setSearchSegments from 'owa-mail-search-store/lib/actions/searchText/setSearchSegments';
/**
 * This mutator does the heavy lifting with respect to filling in ghost text for
 * the user. For suggestions that support pills (i.e. people, categories), it will
 * add the pill to search box. For other suggestions (i.e. keywords), it will simply
 * replace the text in the input.
 */
export default mutatorAction('completeGhostTextSuggestion', function completeGhostTextSuggestion() {
    // If there isn't a suggestion, return.
    var suggestion = getSuggestionAtIndex(0 /* index */);
    if (!suggestion) {
        return;
    }
    lazyLogSearchBoxStateChanged.importAndExecute(new Date() /* currentTime */, 'ghost' /* reason */, suggestion.ReferenceId, getSuggestionsSet().TraceId);
    /**
     * - If suggestion pill suggestion, add pill and clear searchTextForSuggestion.
     * - If keyword suggestion, set searchText and searchTextForSuggestion as
     *   the text of the suggestion.
     */
    switch (suggestion.kind) {
        case SuggestionKind.People:
        case SuggestionKind.Category: {
            suggestionPillActions.addPill(suggestion);
            setSearchTextForSuggestion('');
            break;
        }
        case SuggestionKind.Keywords:
        default: {
            var firstSuggestionText = getSuggestionText(0 /* index */);
            var firstSuggestionSegments = getSuggestionSegments(0 /*index*/);
            if (firstSuggestionSegments) {
                setSearchSegments(firstSuggestionSegments);
            }
            else {
                setSearchText(firstSuggestionText);
            }
            setSearchTextForSuggestion(firstSuggestionText);
        }
    }
});
//# sourceMappingURL=completeGhostTextSuggestion.js.map